// Interfaces
import { Case, Patient, PatientDiagnosis } from '../interfaces/Patient';

// Other
import moment from 'moment';
import { UserData } from '../interfaces/UserInfo';
import { timeBetweenDatesInMs } from './Date';

/* 
    FUNCTIONS THAT RETURN PARAMETERS OF A PATIENT
*/
// capitalizes a word
const capitalize = (word: string | undefined | null) => {
    if (word === undefined || word === null) return '';
    return word.split(' ').map(name => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()).join(' ');
};

const capitalizeOrEmpty = (value: string | undefined) => {
    return value ? capitalize(value) + ' ' : '';
};

const deleteLastEmptyChar = (value: string) => value[value.length - 1] === ' ' ? value.slice(0, -1) : value;

// returns  a string with the full name of a Patient.
export const getFullName = (patient: Patient | UserData | undefined | null) => {
    if (patient === null || patient === undefined) return '';
    return deleteLastEmptyChar(capitalizeOrEmpty(patient.first_name) + capitalizeOrEmpty(patient.middle_name) +
        capitalizeOrEmpty(patient.last_name_1) + capitalizeOrEmpty(patient.last_name_2));
};

// returns the patient's bed
export const getPatientBedName = (patient: Patient) => {
    return patient.cases?.[0].follow_ups?.[0]?.bed?.name ?? '';
};

export const getCaseBedName = (caso: Case) => {
    return caso.follow_ups?.[0]?.bed?.name ?? caso.follow_ups?.[0]?.bed?.id ?? '-'
}

// returns a string with the discharge status.
export const getDischargeStatusPatient = (patient: Patient) => {
    if (patient.cases.length > 0 && patient.cases[0].out_days) {
        const diffDate = Number(patient.cases[0].out_days);
        if (diffDate === -1) return 'HAD';
        else if (diffDate <= 7 && diffDate > -1) return 'seven-days';
        else if (diffDate > 7) return 'thirty-days';
        else return '';
    }
    else return '';
};

// returns a string with the zone name of a patient.
export const getZonePatient = (patient: Patient) => {
    if (patient.beds && patient.beds.length > 0)
        return patient.beds[0].zone?.name || '';
    else return '';
};

// returns a number with the age of a patient.
export const getAgePatient = (patient: Patient) => {
    return moment().diff(moment(patient.birth_date), 'years') || '';
};

// returns a string with a patient's town name.
export const getTownNamePatient = (patient: Patient | undefined | null) => {
    if (patient === undefined || patient === null) return '';
    return patient.addresses && patient.addresses.length > 0 && patient.addresses[0].town && patient.addresses[0].town.name ?
        capitalize(patient.addresses[0].town.name) : '';
};

// returns a string with the patient's allergies
export const getAllergiesPatient = (patient: Patient) => {
    if (!patient.allergies || patient.allergies.length === 0) return '';
    const allergiesDescriptions = patient.allergies.map((allergy) => {
        return allergy.description ?? null;
    }).filter(allergy => allergy !== null);


    return allergiesDescriptions.join(', ');
};

// returns a string with the patient preconfig
export const getPreconfigPatient = (patient: Patient) =>
    patient.patient_preconfigs?.[0]?.preconfig?.name ?? '';

export const getDiagnosisCase = (diagnosisArray: PatientDiagnosis[]) => {
    return diagnosisArray?.[0]?.diagnosis?.description ?? ''
}

export const getDiagnosisPatient = (patient: Patient) => {
    if (!patient.cases || patient.cases.length === 0 || !patient.cases[0].patient_diagnosis
        || patient.cases[0].patient_diagnosis.length === 0) return '';
    return getDiagnosisCase(patient.cases[0].patient_diagnosis);
};

// returns a string with the address
export const getAddress = (patient: Patient | null) => capitalize(patient?.addresses?.[0]?.street ?? '') + ', ' +
    capitalize(patient?.addresses?.[0]?.town?.name ?? '-');

export const getDaysStayTime = (patient: Patient) => {
    const caso = patient.cases?.[0];
    if (patient === undefined || patient === null || !caso) return '-';
    const caseElapsedTimeMs = timeBetweenDatesInMs(caso.start_date, caso.end_date);
    if (caseElapsedTimeMs === null) return '-';
    return Math.round(caseElapsedTimeMs / 1000 / 60 / 60 / 24); // convert to days
}